/*
 *
 * ResetPassword constants
 *
 */

// LOAD
export const LOAD_RESETPASSWORD = 'app/ResetPassword/LOAD_RESETPASSWORD';
export const LOAD_RESETPASSWORD_SUCCESS =
  'app/ResetPassword/LOAD_RESETPASSWORD_SUCCESS';
export const LOAD_RESETPASSWORD_ERROR =
  'app/ResetPassword/LOAD_RESETPASSWORD_ERROR';

// CHANGE/UPDATE
export const CHANGE_RESETPASSWORD = 'app/ResetPassword/CHANGE_RESETPASSWORD';
export const CHANGE_RESETPASSWORD_SUCCESS =
  'app/ResetPassword/CHANGE_RESETPASSWORD_SUCCESS';
export const CHANGE_RESETPASSWORD_ERROR =
  'app/ResetPassword/CHANGE_RESETPASSWORD_ERROR';

// DELETE
export const DELETE_RESETPASSWORD = 'app/ResetPassword/DELETE_RESETPASSWORD';
export const DELETE_RESETPASSWORD_SUCCESS =
  'app/ResetPassword/DELETE_RESETPASSWORD_SUCCESS';
export const DELETE_RESETPASSWORD_ERROR =
  'app/ResetPassword/DELETE_RESETPASSWORD_ERROR';

export const FLUSH_STATE_RESETPASSWORD =
  'app/ResetPassword/FLUSH_STATE_RESETPASSWORD';
